// extracted by mini-css-extract-plugin
export var certifications = "certifications-module--certifications--3Aybm";
export var item = "certifications-module--item--2se82";
export var png = "certifications-module--png--2YBrn";
export var gatsbyImage = "certifications-module--gatsbyImage--3RnX7";